module.exports = __webpack_public_path__ + "assets/7a1e72965e726ad549b298583a28a1c6.png";